import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据 
export const fetchDataConfig = query => { 
    var list = request({
        url: 'comMemGoods/selectPageConfig.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const fetchData3 = query => {
    var list = request({
        url: 'comMemgoodsPriceHis/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const saveForm3 = query => {
    var list = request({
        url: 'comMemgoodsPriceHis/insert.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const handDelete3 = query => {
    var list = request({
        url: 'comMemgoodsPriceHis/delete.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const changeStatus2 = query => {  
    var list = request({
        url: 'comGoodsConfig/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeStatus3 = query => {  
    var list = request({
        url: 'comGoodsConfig/changeLimitStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeStatus4 = query => {  
    var list = request({
        url: 'comGoodsConfig/changeRiskStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; export const changeStatus5 = query => {  
    var list = request({
        url: 'comGoodsConfig/changeIsLink.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 
export const changeVal = query => {  
    var list = request({
        url: 'comMemGoods/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const getCityData = query => { 
    var list = request({
        url: 'comGoodsConfig/getCityData.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 
export const changeCityVal = query => { 
    var list = request({
        url: 'comGoodsConfig/changeCityVal.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeCityStatus = query => { 
    var list = request({
        url: 'comGoodsConfig/changeCityStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const setDeducPercent = query => {  
    var list = request({
        url: 'comGoodsConfig/setDeducPercent.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const setLimitConfig = query => { 
    var list = request({
        url: 'comGoodsConfig/setLimitConfig.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const changeStatusBatch = query => {  
    var list = request({
        url: 'comGoodsConfig/changeStatusMore.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

 
 




